import { render } from "./ShowReqPartModal.vue?vue&type=template&id=71f6040a&scoped=true"
import script from "./ShowReqPartModal.vue?vue&type=script&lang=js"
export * from "./ShowReqPartModal.vue?vue&type=script&lang=js"

import "./ShowReqPartModal.vue?vue&type=style&index=0&id=71f6040a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f6040a"]])

export default __exports__